import {Segment} from 'semantic-ui-react';
import Fetcher from '../shared/fetches/fetcher';
import {fetchStudentCoursesDurationData} from '../../redux/actions/student-courses-duration-data';
import StudentCourses from './student-courses';

function Container() {
  return (
    <Fetcher
      action={fetchStudentCoursesDurationData}
      stateSelector={state => state.studentCoursesDurationData}
      renderEmpty={renderEmpty}
    >
      {studentCoursesData => <StudentCourses studentCourses={studentCoursesData}/>}
    </Fetcher>
  );
}

function renderEmpty() {
  return (<Segment textAlign='center' content='تاکنون هیچ کورسی به پایان نرسیده است.'/>);
}

export default Container;
